"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
require("./Select.css");
var Icon_1 = require("../icon/Icon");
var Button_1 = require("../button/Button");
var useOnClickOutside_1 = require("../../hooks/useOnClickOutside");
var string_1 = require("../../utils/string");
var Link_1 = require("../link/Link");
var useOnTabOutside_1 = require("../../hooks/useOnTabOutside");
var keyboard_1 = require("../../utils/dom/keyboard");
var scroll_1 = require("../../utils/dom/scroll");
var SelectTheme;
(function (SelectTheme) {
    SelectTheme["basic"] = "basic";
    SelectTheme["box"] = "box";
    SelectTheme["boxMulti"] = "boxMulti";
})(SelectTheme = exports.SelectTheme || (exports.SelectTheme = {}));
var SelectComp = function (props) {
    var _a = __read((function (_a) {
        var selectItems = _a.selectItems, autoAlign = _a.autoAlign, defaultLabel = _a.defaultLabel, defaultTitle = _a.defaultTitle, selectedIndex = _a.selectedIndex, startSelectedIndex = _a.startSelectedIndex, disabled = _a.disabled, icon = _a.icon, hasError = _a.hasError, overlayItems = _a.overlayItems, showSelectedLabel = _a.showSelectedLabel, searchable = _a.searchable, formatSelectedLabel = _a.formatSelectedLabel, dismissOnChange = _a.dismissOnChange, theme = _a.theme, onOpen = _a.onOpen, onClose = _a.onClose, onChange = _a.onChange, 
        //input specific
        autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, spellCheck = _a.spellCheck, autoCapitalize = _a.autoCapitalize, ariaLabel = _a["aria-label"], ariaDescribedBy = _a["aria-describedby"], ariaRequired = _a["aria-required"], rest = __rest(_a, ["selectItems", "autoAlign", "defaultLabel", "defaultTitle", "selectedIndex", "startSelectedIndex", "disabled", "icon", "hasError", "overlayItems", "showSelectedLabel", "searchable", "formatSelectedLabel", "dismissOnChange", "theme", "onOpen", "onClose", "onChange", "autoComplete", "autoCorrect", "spellCheck", "autoCapitalize", 'aria-label', 'aria-describedby', 'aria-required']);
        return [
            rest,
            {
                autoComplete: autoComplete,
                autoCorrect: autoCorrect,
                spellCheck: spellCheck,
                autoCapitalize: autoCapitalize,
                'aria-label': ariaLabel,
                'aria-describedby': ariaDescribedBy,
                'aria-required': ariaRequired,
            },
        ];
    })(props), 2), htmlProps = _a[0], inputProps = _a[1];
    //--- refs ---//
    var el = react_1.useRef(null);
    var onCloseRef = react_1.useRef();
    var selectItemsRef = react_1.useRef([]);
    var selectScrollContainerRef = react_1.useRef(null);
    var SelectItemsContainerId = react_1.useRef(string_1.getRandomString());
    var searchInputRef = react_1.useRef(null);
    var activedescendantId = react_1.useRef(string_1.getRandomString());
    var scrollOffset = react_1.useRef([0, 0]);
    //--- states ---//
    var _b = __read(react_1.useState(props.startSelectedIndex), 2), curIndex = _b[0], setCurIndex = _b[1]; //selected Item index
    var _c = __read(react_1.useState(-1), 2), focusedIndex = _c[0], setFocusedIndex = _c[1]; //focused Item index of props.selectItems list
    var _d = __read(react_1.useState([]), 2), filteredIndexes = _d[0], setFilteredIndexes = _d[1]; //list of props.selectItems indexes filtered by search value
    var _e = __read(react_1.useState(false), 2), expanded = _e[0], setExpanded = _e[1];
    var _f = __read(react_1.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    }), 2), dropdownOutside = _f[0], setDropdownOutside = _f[1];
    var _g = __read(react_1.useState(''), 2), searchValue = _g[0], setSearchValue = _g[1];
    //--- effects ---//
    react_1.useEffect(function () {
        selectItemsRef.current = props.selectItems.map(function () { return React.createRef(); });
        if (props.selectedIndex === undefined &&
            props.selectItems.length <= curIndex)
            setCurIndex(-1);
    }, [props.selectItems]);
    react_1.useEffect(function () {
        if (props.selectedIndex !== undefined)
            setCurIndex(props.selectedIndex);
        if (props.dismissOnChange && expanded)
            setExpanded(false);
    }, [props.selectedIndex]);
    react_1.useEffect(function () {
        if (props.disabled) {
            setExpanded(false);
            searchReset();
        }
    }, [props.disabled]);
    react_1.useEffect(function () {
        onCloseRef.current = props.onClose;
    }, [props.onClose]);
    useOnClickOutside_1.useOnClickOutside(el, function (e) {
        setExpanded(false);
        searchReset();
        if (onCloseRef.current && expanded) {
            onCloseRef.current(e);
        }
    }, [expanded]);
    useOnTabOutside_1.useOnTabOutside(el, function (e) {
        setExpanded(false);
        searchReset();
        if (onCloseRef.current && expanded) {
            onCloseRef.current(e);
        }
    }, [expanded]);
    react_1.useEffect(function () {
        if (expanded) {
            if (props.theme === SelectTheme.boxMulti) {
                scrollOffset.current = [0, 0];
            }
            searchInputRef.current.focus();
            var startIndex = curIndex > -1 ? curIndex : 0;
            setFocusedIndex(startIndex);
            scroll_1.scrollToItemStart(selectScrollContainerRef.current, selectItemsRef.current[startIndex].current);
        }
    }, [expanded]);
    //keep horizontal scroll in same position
    if (props.theme === SelectTheme.boxMulti &&
        selectScrollContainerRef.current) {
        selectScrollContainerRef.current.scrollLeft = scrollOffset.current[1];
    }
    //--- utility methods ---//
    function isOutsideViewport(el, offset) {
        if (offset === void 0) { offset = { top: 0, right: 0, bottom: 0, left: 0 }; }
        var bounding = el.getBoundingClientRect();
        return {
            top: bounding.top + offset.top < 0,
            left: bounding.left + offset.left < 0,
            bottom: bounding.bottom + offset.bottom >
                (window.innerHeight || document.documentElement.clientHeight),
            right: bounding.right + offset.right >
                (window.innerWidth || document.documentElement.clientWidth),
        };
    }
    function searchItem(inputValue) {
        if (inputValue && inputValue.length > 0) {
            if (inputValue === ' ')
                return;
            var filteredItemsIndexes_1 = [];
            props.selectItems.forEach(function (item, index) {
                if (!item.disabled) {
                    if (item.searchTerms) {
                        item.searchTerms.forEach(function (t) {
                            var term = t.toLowerCase().trim();
                            var val = inputValue.toLowerCase().trim();
                            if (term.includes(val)) {
                                filteredItemsIndexes_1.push(index);
                            }
                        });
                    }
                    else
                        throw new Error('SelectItem.searchTerms are required when Select.searchable is true');
                }
            });
            setSearchValue(inputValue);
            if (filteredItemsIndexes_1.length > 0) {
                setFocusedIndex(0);
                setFilteredIndexes(filteredItemsIndexes_1);
                scroll_1.scrollToItemStart(selectScrollContainerRef.current, selectItemsRef.current[filteredItemsIndexes_1[0]].current);
            }
            else {
                setFocusedIndex(-1);
                setFilteredIndexes([]);
                scroll_1.scrollToItemStart(selectScrollContainerRef.current, selectItemsRef.current[0].current);
            }
        }
        else {
            searchReset();
            scroll_1.scrollToItemStart(selectScrollContainerRef.current, selectItemsRef.current[0].current);
        }
    }
    var searchReset = function () {
        setSearchValue('');
        if (props.dismissOnChange)
            setFocusedIndex(-1);
        setFilteredIndexes([]);
    };
    //--- handlers ---//
    var onSelectClick = function (e) {
        if (props.disabled)
            return;
        setExpanded(function (prevState) { return !prevState; });
        if (expanded) {
            if (onCloseRef.current) {
                onCloseRef.current(e);
            }
        }
    };
    var onSearchInputChange = function (e) {
        if (props.disabled)
            return;
        searchItem(e.target.value);
    };
    var onSearchInputKeyUp = function (e) {
        var _a;
        if (props.disabled)
            return;
        if (expanded) {
            var hasInputValue = e.target.value.length > 0;
            //return key
            if (keyboard_1.isKeyReturn(e) || (keyboard_1.isKeySpacebar(e) && !hasInputValue)) {
                var index = filteredIndexes.length > 0
                    ? filteredIndexes[focusedIndex]
                    : focusedIndex;
                if ((_a = props.selectItems[index]) === null || _a === void 0 ? void 0 : _a.disabled)
                    return;
                searchReset();
                if (props.dismissOnChange)
                    setExpanded(false);
                if (props.selectedIndex === undefined)
                    setCurIndex(index);
                if (props.onChange) {
                    props.onChange(props.selectItems[index], index, e);
                }
                if (props.onClose && props.dismissOnChange) {
                    props.onClose(e);
                }
            }
            //up arrow
            else if (keyboard_1.isKeyArrowUp(e)) {
                if (focusedIndex > 0) {
                    setFocusedIndex(function (prevState) {
                        var index = prevState - 1;
                        var itemRefIndex = filteredIndexes.length > 0 ? filteredIndexes[index] : index;
                        var itemRef = selectItemsRef.current[itemRefIndex];
                        var scrollEl = selectScrollContainerRef.current;
                        if (props.theme === SelectTheme.boxMulti) {
                            itemRef.current.querySelector('.Checkbox_input').focus();
                        }
                        scroll_1.scrollToItemWhenOutsideVisibleScroll(selectScrollContainerRef.current, itemRef.current);
                        return index;
                    });
                }
            }
            //down arrow
            else if (keyboard_1.isKeyArrowDown(e)) {
                var length_1 = filteredIndexes.length > 0
                    ? filteredIndexes.length
                    : props.selectItems.length;
                if (focusedIndex < length_1 - 1) {
                    setFocusedIndex(function (prevState) {
                        var index = prevState + 1;
                        var itemRefIndex = filteredIndexes.length > 0 ? filteredIndexes[index] : index;
                        var itemRef = selectItemsRef.current[itemRefIndex];
                        var scrollEl = selectScrollContainerRef.current;
                        if (props.theme === SelectTheme.boxMulti) {
                            itemRef.current.querySelector('.Checkbox_input').focus();
                        }
                        scroll_1.scrollToItemWhenOutsideVisibleScroll(selectScrollContainerRef.current, itemRef.current);
                        return index;
                    });
                }
            }
        }
        //collapsed or collapsing
        else {
            if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e)) {
                setExpanded(true);
            }
        }
    };
    var onItemMouseOver = function (e, item, index) {
        var fIndex = filteredIndexes.length > 0 ? filteredIndexes.indexOf(index) : index;
        setFocusedIndex(fIndex);
    };
    var onItemClick = function (e, item, index) {
        if (props.disabled || item.disabled)
            return;
        if (props.dismissOnChange)
            setExpanded(false);
        if (props.selectedIndex === undefined)
            setCurIndex(index);
        searchReset();
        if (props.onChange) {
            props.onChange(item, index, e);
        }
        if (onCloseRef.current && props.dismissOnChange) {
            onCloseRef.current(e);
        }
    };
    var selectedItem = curIndex > -1 ? props.selectItems[curIndex] : undefined;
    var selectedLabel = selectedItem && props.showSelectedLabel
        ? props.formatSelectedLabel
            ? props.formatSelectedLabel(selectedItem)
            : selectedItem.label
        : props.defaultLabel || 'Please Select';
    return (React.createElement("div", __assign({}, htmlProps, { ref: el, className: classnames_1.default('Select', "Select-" + props.theme, props.className, {
            'Select-error': props.hasError,
            'Select-active': expanded && props.selectItems.length > 0,
            'Select-disabled': props.disabled,
        }) }),
        React.createElement("div", { className: "Select_toggle", tabIndex: -1, onClick: onSelectClick },
            React.createElement("div", { className: 'Select_item Select_item-default' },
                React.createElement("span", { className: classnames_1.default('Select_label', {
                        'Select_label-hidden': searchValue.length > 0,
                    }), title: selectedItem && selectedItem.title && props.showSelectedLabel
                        ? selectedItem.title
                        : props.defaultTitle }, selectedLabel),
                props.icon && React.createElement(Icon_1.Icon, { className: "Select_icon", type: props.icon }),
                React.createElement("input", __assign({}, inputProps, { ref: searchInputRef, className: 'Select_searchInput', value: searchValue, readOnly: !(props.searchable && expanded), role: 'combobox', "aria-label": inputProps['aria-label'] || typeof selectedLabel === 'string'
                        ? selectedLabel
                        : 'Select', "aria-autocomplete": 'list', "aria-haspopup": 'listbox', "aria-expanded": expanded, "aria-owns": SelectItemsContainerId.current, "aria-activedescendant": expanded ? activedescendantId.current : undefined, onChange: onSearchInputChange, onKeyUp: onSearchInputKeyUp })))),
        React.createElement(react_transition_group_1.CSSTransition, { in: expanded && props.selectItems.length > 0, timeout: 200, classNames: "Select_dropdown", appear: true, unmountOnExit: true, onEnter: function (dropdown) {
                if (el.current) {
                    //const dropdown = el.current.querySelector('.Select_dropdown');
                    var out = isOutsideViewport(dropdown, {
                        top: 15,
                        right: 15,
                        left: 15,
                        bottom: 15,
                    });
                    setDropdownOutside(out);
                }
                if (props.onOpen)
                    props.onOpen(dropdown);
            }, onExited: function () {
                setDropdownOutside({
                    top: false,
                    left: false,
                    bottom: false,
                    right: false,
                });
            } },
            React.createElement("div", { ref: selectScrollContainerRef, className: classnames_1.default('Select_dropdown', {
                    'Select_dropdown-overlay': props.overlayItems,
                    'Select_dropdown-top': props.autoAlign && dropdownOutside.top,
                    'Select_dropdown-right': props.autoAlign && dropdownOutside.right,
                    'Select_dropdown-bottom': props.autoAlign && dropdownOutside.bottom,
                    'Select_dropdown-left': props.autoAlign && dropdownOutside.left,
                }) },
                React.createElement("div", { id: SelectItemsContainerId.current, className: classnames_1.default('Select_items', {
                        'Select_items-searchable': props.searchable,
                    }), role: 'listbox' }, props.selectItems.map(function (_a, index) {
                    var _b = _a.tabIndex, tabIndex = _b === void 0 ? -1 : _b, item = __rest(_a, ["tabIndex"]);
                    var hasFocus = index ===
                        (filteredIndexes.length > 0
                            ? filteredIndexes[focusedIndex]
                            : focusedIndex);
                    return item.route ? (React.createElement(Link_1.Link, { role: 'option', id: hasFocus ? activedescendantId.current : undefined, key: index, to: item.route, tabIndex: tabIndex, ref: selectItemsRef.current[index], disabled: props.disabled || item.disabled, className: classnames_1.default('Select_item', {
                            'Select_item-disabled': item.disabled,
                            'Select_item-active': index === curIndex,
                            'Select_item-focus': hasFocus,
                            'Select_item-filteredOut': filteredIndexes.length > 0 &&
                                !filteredIndexes.includes(index),
                        }), "aria-selected": curIndex === index, "aria-label": typeof item.label === 'string' && curIndex === index
                            ? item.label + " (selected)"
                            : undefined, onMouseOver: function (e) {
                            return onItemMouseOver(e, item, index);
                        }, onClick: function (e) { return onItemClick(e, item, index); } },
                        item.label,
                        props.theme === SelectTheme.box && (React.createElement(Icon_1.Icon, { className: 'Select_itemIcon', type: Icon_1.IconType.check })))) : typeof item.label === 'string' ? (React.createElement(Button_1.Button, { role: 'option', id: hasFocus ? activedescendantId.current : undefined, key: index, 
                        // ref={butRef => {
                        //   selectItemsRef.current[index] = butRef
                        // }}
                        className: classnames_1.default('Select_item', {
                            'Select_item-disabled': item.disabled,
                            'Select_item-active': index === curIndex,
                            'Select_item-focus': hasFocus,
                            'Select_item-filteredOut': filteredIndexes.length > 0 &&
                                !filteredIndexes.includes(index),
                        }), ref: selectItemsRef.current[index], disabled: props.disabled || item.disabled, tabIndex: tabIndex, "aria-selected": curIndex === index, "aria-label": typeof item.label === 'string' && curIndex === index
                            ? item.label + " (selected)"
                            : undefined, onMouseOver: function (e) {
                            return onItemMouseOver(e, item, index);
                        }, onClick: function (e) { return onItemClick(e, item, index); } },
                        item.label,
                        props.theme === SelectTheme.box && (React.createElement(Icon_1.Icon, { className: 'Select_itemIcon', type: Icon_1.IconType.check })))) : (React.createElement("div", { role: 'option', id: hasFocus ? activedescendantId.current : undefined, key: index, 
                        // ref={butRef => {
                        //   selectItemsRef.current[index] = butRef
                        // }}
                        className: classnames_1.default('Select_item', {
                            'Select_item-disabled': item.disabled,
                            'Select_item-active': index === curIndex,
                            'Select_item-focus': hasFocus,
                            'Select_item-filteredOut': filteredIndexes.length > 0 &&
                                !filteredIndexes.includes(index),
                        }), ref: selectItemsRef.current[index], "aria-disabled": props.disabled || item.disabled, "aria-selected": curIndex === index, "aria-label": typeof item.label === 'string' && curIndex === index
                            ? item.label + " (selected)"
                            : undefined, tabIndex: tabIndex, onMouseOver: function (e) {
                            var _a, _b;
                            if (props.theme === SelectTheme.boxMulti) {
                                scrollOffset.current = [
                                    ((_a = selectScrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0,
                                    ((_b = selectScrollContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) || 0,
                                ];
                            }
                            onItemMouseOver(e, item, index);
                        }, onMouseDown: function () {
                            var _a, _b;
                            if (props.theme === SelectTheme.boxMulti) {
                                scrollOffset.current = [
                                    ((_a = selectScrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0,
                                    ((_b = selectScrollContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) || 0,
                                ];
                            }
                        }, onClick: function (e) {
                            if (props.disabled || item.disabled)
                                return;
                            onItemClick(e, item, index);
                        } },
                        item.label,
                        props.theme === SelectTheme.box && (React.createElement(Icon_1.Icon, { className: 'Select_itemIcon', type: Icon_1.IconType.check }))));
                }))))));
};
SelectComp.defaultProps = {
    defaultLabel: 'Please Select',
    autoAlign: true,
    hasError: false,
    disabled: false,
    overlayItems: true,
    theme: SelectTheme.basic,
    showSelectedLabel: true,
    startSelectedIndex: -1,
    searchable: false,
    dismissOnChange: true,
    //input specific
    autoComplete: 'off',
    autoCorrect: 'off',
    autoCapitalize: 'none',
    spellCheck: false,
};
exports.Select = React.memo(SelectComp);
